import styled from "styled-components";

export const InfoBottomView = styled.section`
	display: flex;
	justify-content: space-between;
	font-size: 12px;
	color: #999;
`;
